<template>
    <div id="app">
        <navigation/>
        <div class="w_8">
            <el-row :gutter="100" style="margin-left:100px">
                <div v-for="(item,index) in data" @click="select(index)" >
                    <el-col :span="7" >
                        <div class="grid-content bg-purple" :class="buyId==index?'buyStyle':''" v-if="item.type == '1'">
                            <p>套餐：{{item.title}}</p>
                            <p>套餐说明：{{item.remark}}</p>
                            <p>套餐详情：{{item.num}}次/{{item.price}}元</p>
                        </div>
                        <div class="grid-content bg-purple" :class="buyId==index?'buyStyle':''" v-else>
                            <p>套餐：{{item.title}}</p>
                            <p>套餐说明：{{item.price}}/年</p>
                            <p>套餐详情：{{item.num}}次</p>
                        </div>
                    </el-col>
                </div>
            </el-row>
            <el-button type="success" style="margin-left:42%;margin-top:60px;width:200px" @click="toBuy" >立即购买</el-button>
        </div>
    </div>
</template>



<script>
import Navigation from '@/components/area/Navigation.vue'
import {createOrderApi , packageListApi} from '@/service/allApi'
import Axios from 'axios'
export default {
    data(){
        return{
            buyId:0 ,
            data:[]
      }
    },
    created(){
      this.getPackage();
    },
    methods:{
        select(id){
            var that = this
            that.buyId = id
        },
       async toBuy(){
          var that = this;
          var dataPackage = that.data[that.buyId];

          localStorage.setItem("dataPackage",JSON.stringify(dataPackage))
          //进入后台进行创建订单，然后在进行跳转
          var data = {
            packageId:that.data[that.buyId].id
          }

          var res = await createOrderApi(data);
          if(res.data.code === 100){
              localStorage.setItem("orderNo",res.data.data.orderNo)
              that.$router.push('/pay')
          }else{
              that.$router.push('/login')
          }
        },
      async  getPackage(){
          const res = await packageListApi()
          if(res.data.code == 100){
              if(res.data.list!=null){
                  this.data = res.data.list
              }else{
                  alert('暂无数据');
              }
          }
        }
    },
    components: {
        navigation: Navigation
    }
}
</script>


<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    height: 160px;
    margin-top: 40px;
    text-align: left;
    line-height: 40px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .buyStyle{
    background: -webkit-linear-gradient( rgb(249,120,102) ,rgb(245,57,46),rgb(238,27,21));
    text-align: center;
  }
  .w_8{
      width: 97%;
  }
</style>


// WEBPACK FOOTER //
// src/components/store.vue